<template>
    <div class="uk-overlay-default uk-position-cover uk-position-z-index uk-flex uk-flex-middle" v-show="visible">
        <div :class="type">
            <div v-for="i in elements"></div>
        </div>
    </div>
</template>
<script>
  export default {
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: 'flipping-square',
      },
      elements: {
        type: Number,
        default: 0,
      }
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/assets/js/theme-components/Loader.vue